export enum FIELDS {
  password = 'password',
  password_confirmation = 'password_confirmation',
  email = 'email',
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export enum FIELD_TYPES {
  number = 'number',
  connected = 'connected',
  organisationBankAccount = 'organisationBankAccount',
  department = 'department',
  account = 'account',
  program = 'program',
  string = 'string',
  date = 'date',
  boolean = 'boolean',
  country = 'country',
  salutation = 'salutation',
  gender = 'gender',
  group = 'group',
  listSingle = 'single-list',
  listMultiple = 'multiple-list',
  money = 'money',
  percent = 'percent',
  phone = 'phone',
  invoiceStatus = 'invoice_status',
  invoicePaymentStatus = 'invoice_payment_status',
  paymentType = 'payment_type',
  paymentStatus = 'payment_status',
  contact = 'contact',
  datetime = 'datetime',
  emailStatus = 'emailStatus',
  eventType = 'eventType',
  ambassador = 'ambassador',
}

// Arrays of keys for each part of the FundraisingModel
export const FUNDRAISING_INFO_KEYS = [
  'id',
  'type',
  'name',
  'slug',
  'active',
  'default_language',
  'start_date',
  'end_date',
  'has_end',
  'show_countdown',
  'countdown_end_date',
  'ask_for_fee',
  'admin_fee',
  'show_suggested',
  'max_amount',
  'program_id',
  'department_id',
  'account_id',
  'bank_account_id',
  'payment_gateway_id',
  'allow_installment',
  'max_installments',
  'groups_id',
  'button_labels',
] as const;

export const MATCHING_INFO_KEYS = [
  'active_matching',
  'bonus_round_active',
  'bonus_round_goal',
  'end_amount_multiplier',
  'matching_multiplier',
  'goal',
  'show_goal',
  'show_raised_amount',
  'start_amount_multiplier',
] as const;

export const PRODUCTS_KEYS = [
  'all_products_visible', 'show_in_dropdown', 'fixed_price_as_checkbox',
  'fixed_price_allow_quantity', 'product_fee_id', 'product_suggested_id', 'products',
] as const;

export const AMBASSADORS_KEYS = [
  'message_sms', 'message_email_title', 'message_email', 'show_ambassador_section', 'show_ambassador_goal',
  'show_ambassador_real_amount', 'show_donors_section', 'show_donor_real_amount',
  'show_donor_amount', 'show_donors_comments',
] as const;

export const NOTIFICATIONS_KEYS = [
  'contacts', 'send_thanks_email', 'thanks_email_title', 'thanks_email_body',
  'send_thanks_sms', 'thanks_sms_text', 'send_email_notifications',
  'send_sms_notifications', 'fb_title', 'fb_description',
] as const;

export function pick<T, K extends readonly (keyof T)[]>(obj: any, keys: K): Pick<T, K[number]> {
  const result = {} as Pick<T, K[number]>;
  keys.forEach((key) => {
    if (key in obj) {
      result[key] = obj[key];
    }
  });
  return result;
}
